import { useEffect } from 'react';

import { HiddenInput } from '@toolbox/components';
import { useField } from '@toolbox/form';

import type { HiddenInputProps } from '@toolbox/components';
import type { FieldPath, FieldValues, UseFieldProps } from '@toolbox/form';
import type { RequiredBy } from '@toolbox/utils';

export type HiddenFieldProps<
  FD extends FieldValues = FieldValues,
  Name extends FieldPath<FD> = FieldPath<FD>,
> = UseFieldProps<FD, Name> & RequiredBy<HiddenInputProps, 'name'>;

export function HiddenField<
  FD extends FieldValues = FieldValues,
  Name extends FieldPath<FD> = FieldPath<FD>,
>({ required, rules, ...props }: HiddenFieldProps<FD, Name>): JSX.Element {
  const {
    field: { ref, ...field },
  } = useField({
    name: props.name,
    rules: {
      required,
      ...rules,
    },
  });

  useEffect(() => {
    let val: string | number | boolean = props.storyBlokValue;
    if (props.type == 'number') {
      val = Number(props.storyBlokValue);
    }
    if (props.type == 'boolean') {
      val = props.storyBlokValue !== 'false';
    }
    field.onChange(val);
  }, [field, props.storyBlokValue, props.type]);

  return <HiddenInput {...props} {...field} />;
}
